module.exports = __webpack_public_path__ + "img/product-icon_1.360f7d57.png";